module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/close02-4855043c86011e96a9a5ffff8ecfca81.svg";